export const NOTIFICATION_PRIORITY = {
  silence: 'silence',
  normal: 'normal',
  important: 'important',
  fatal: 'fatal',
}

export const NOTIFICATION_SEND_TYPE = {
  notice: 'notice',
  announcement: 'announcement',
}
